export const complyance = {
  complyance1: '#fdfdff',
  complyance2: '#f7f8ff',
  complyance3: '#eef1ff',
  complyance4: '#e1e7ff',
  complyance5: '#d4dcff',
  complyance6: '#c4cdff',
  complyance7: '#aeb8ff',
  complyance8: '#919aff',
  complyance9: '#4b21ec',
  complyance10: '#4100d9',
  complyance11: '#523eef',
  complyance12: '#261f76',
};

export const complyanceA = {
  complyance1: '#0000ff02',
  complyance2: '#0020ff08',
  complyance3: '#002dff11',
  complyance4: '#0033ff1e',
  complyance5: '#0130ff2b',
  complyance6: '#0127ff3b',
  complyance7: '#0020ff51',
  complyance8: '#0015ff6e',
  complyance9: '#3000e9de',
  complyance10: '#4100d9',
  complyance11: '#1b00eac1',
  complyance12: '#080063e0',
};

export const complyanceDark = {
  complyance1: '#0e0f1f',
  complyance2: '#13152b',
  complyance3: '#1e1d56',
  complyance4: '#271e7b',
  complyance5: '#30288c',
  complyance6: '#39349c',
  complyance7: '#4440b2',
  complyance8: '#524cd4',
  complyance9: '#4b21ec',
  complyance10: '#4100d9',
  complyance11: '#a2acff',
  complyance12: '#d9dfff',
};

export const complyanceDarkA = {
  complyance1: '#0000ff0f',
  complyance2: '#2436fe1c',
  complyance3: '#3e3bff4a',
  complyance4: '#432fff72',
  complyance5: '#4d3eff84',
  complyance6: '#564dff95',
  complyance7: '#5d57ffad',
  complyance8: '#6059ffd1',
  complyance9: '#5023ffeb',
  complyance10: '#4a00fed7',
  complyance11: '#a2acff',
  complyance12: '#d9dfff',
};
